import useRolePermission from "entities/auth/hooks/useRolePermission";
import React from "react";
import { useThemeTagDetails } from "../../context";
import { StyledButton } from "../../styled";

const ActionButton = () => {
  const { submitting, disabled, onSubmitTag, onSubmitTagTranslation } =
    useThemeTagDetails();
  const { allowed: hasWriteAccess } = useRolePermission("tags:write");
  const { allowed: hasWriteTranslationsAccess } = useRolePermission(
    "tags:translations:write",
  );

  if (!hasWriteAccess && !hasWriteTranslationsAccess) {
    return null;
  }

  if (!hasWriteAccess && hasWriteTranslationsAccess) {
    return (
      <StyledButton
        title="Save"
        size="small"
        disabled={disabled}
        onClick={onSubmitTagTranslation}
        loading={submitting}
      />
    );
  }

  return (
    <StyledButton
      title="Save"
      size="small"
      disabled={disabled}
      onClick={onSubmitTag}
      loading={submitting}
    />
  );
};

export default ActionButton;
